/** @jsxFrag React.Fragment */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { Grid } from '@coursera/cds-core';

import type { WesLogoProps } from 'bundles/composable-page-header-enterprise/components/WesLogoGridItem';
import WesLogo from 'bundles/composable-page-header-enterprise/components/WesLogoGridItem';
import { useEnterpriseMyPageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import type { CommonNavProps } from 'bundles/composable-page-header-enterprise/types/wesHeader';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NotificationsLegacyGridItem from 'bundles/composable-page-header/components/grid-items/NotificationsLegacyGridItem';
import CoachStudioGridItem, {
  showCoachStudio,
} from 'bundles/composable-page-header/components/grid-items/coach/CoachStudioGridItem';
import DefaultAccountDropdownGridItemRenderer from 'bundles/composable-page-header/module-renderers/DefaultAccountDropdownGridItemRenderer';

const desktopNavStyles = {
  logoContainer: css`
    margin-right: var(--cds-spacing-400);
  `,
  searchBarContainer: css`
    margin-left: var(--cds-spacing-800);
  `,
};

export interface WesDesktopNavProps extends WesLogoProps, CommonNavProps {}

function WesDesktopNav(props: WesDesktopNavProps) {
  const enterpriseMyPageHeader = useEnterpriseMyPageHeader();

  return (
    <MainNavigationWrapper>
      <Grid item alignItems="center" container xs={9}>
        <Grid item css={desktopNavStyles.logoContainer}>
          <WesLogo logoType={props.logoType} />
        </Grid>
        {props.renderSearchBar ? (
          <Grid item xs css={desktopNavStyles.searchBarContainer}>
            {props.renderSearchBar()}
          </Grid>
        ) : null}
      </Grid>
      <Grid item alignItems="center" container xs={3} justifyContent="flex-end">
        {isAuthenticatedUser() ? (
          <>
            <Grid item>
              <NotificationsLegacyGridItem />
            </Grid>
            {showCoachStudio() && (
              <Grid item>
                <CoachStudioGridItem />
              </Grid>
            )}
            <Grid item>
              <DefaultAccountDropdownGridItemRenderer
                hasEnrolledPrograms={!!enterpriseMyPageHeader.hasEnrolledPrograms}
                naptimeManagedThirdPartyOrganizations={enterpriseMyPageHeader.naptimeManagedThirdPartyOrganizations}
                hasCheatingIncidents={!!enterpriseMyPageHeader.hasCheatingIncidents}
                canViewEducatorAdminLink={!!enterpriseMyPageHeader.canViewEducatorAdminLink}
                isCourseraPlusLearner={!!enterpriseMyPageHeader.isCourseraPlusLearner}
                courseraPlusSubscriptionCycle={enterpriseMyPageHeader.courseraPlusSubscriptionCycle}
                currentOrganization={enterpriseMyPageHeader.naptimeChosenOrganization}
                organizations={enterpriseMyPageHeader.naptimeOrganizationsWithProgramEnrollments}
                degrees={enterpriseMyPageHeader.enrolledDegreePrograms}
                currentDegree={enterpriseMyPageHeader.chosenDegree}
              />
            </Grid>
          </>
        ) : (
          props.renderLoggedOutCta?.() ?? null
        )}
      </Grid>
    </MainNavigationWrapper>
  );
}

export default WesDesktopNav;
